require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-discover-fourdrinier-house.json") })
        }
      }, "path---news-discover-fourdrinier-house");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-discover-fourdrinier-house!./.cache/json/news-discover-fourdrinier-house.json
// module id = 806
// module chunks = 231608221292675